import React from 'react';
import ModalsGroupA from './ModalsGroupA';
import ModalsPartialPayment from './ModalsPartialPayment';
import ModalsGroupB from './ModalsGroupB';

export default function Modals(props) {
  return (
    <>
      <ModalsGroupA {...props} />
      <ModalsPartialPayment {...props} />
      <ModalsGroupB {...props} />
    </>
  );
}
